<template lang="pug">
.waiter-change-application-message-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="onSend")
    div(slot="modal-title")
      span {{ modalTitle }}

    .waiter-change-application-message-modal-body
      .register-body
        FormInput(
          key-name="タイトル"
          required
          name="title"
          v-model="_title"
          type="text"
          placeholder="タイトル"
          :maxlength="100"
          :validation-rules="{ required: true, max: 100 }"
          :styles="{ width: '340px' }")
          
        FormTextarea(
          key-name="本文"
          required
          name="text"
          v-model="_text"
          placeholder="本文"
          :validation-rules="{ required: true, max: 1000 }"
          :maxlength="1000"
          :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }")

    .waiter-change-application-message-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }")
      .buttons
        button.btn.modal-ok-btn(type="button" @click="ok()") 送信
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import FormLabel from "@/pc/components/forms/FormLabel.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";

/**
 * ### 変更申請受理・不受理メッセージ送信モーダル
 */
@Component({
  components: {
    FormLabel,
    FormInput,
    FormTextarea
  }
})
export default class WaiterChangeApplicationMessageModal extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  @Prop({
    default: () => {
      return "";
    }
  })
  modalTitle!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  title!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  text!: string;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _title(): string {
    return this.title;
  }

  set _title(newValue: string) {
    this.$emit("update:title", newValue);
    return;
  }

  get _text(): string {
    return this.text;
  }

  set _text(newValue: string) {
    this.$emit("update:text", newValue);
    return;
  }

  /**
   * ### 送信ボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public async onSend(modalEvent: any): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      modalEvent.preventDefault();
      this.$emit("onSend");
    }

    return;
  }
}
</script>
